import * as React from 'react'

function FormContainer({ children, className }) {
  return (
    <div className={`flex-1 ${className}`}>
      <div className="pt-8 max-w-screen-xl mx-auto">{children}</div>
    </div>
  )
}

export default FormContainer
